import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HashLocationStrategy, Location, LocationStrategy } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from './../../../../environments/environment'; // Import the environment configuration

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ]
})
export class HeaderComponent implements OnInit {
    location: any;
    styleContainer: any;
    isSubMenu: boolean = false;
    isDomainSubmenu: boolean = false;
    isServiceSubmenu: boolean = false;
    isAboutubmenu: boolean = false;
    loginUrl: string = `${environment.webPageUrl}#/signin`;

   

    constructor(
        private router: Router,
        private titleService: Title,
        location: Location
    ) { }

    ngOnInit() {
        this.titleService.setTitle('VocBot.AI Technologies Pvt. Ltd.');
       
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.location = this.router.url;
                    if (this.location === '/' || this.location === '/home-two' || this.location === '/home-three' || this.location === '/home-four') {
                        this.styleContainer = 'container-fluid';
                    } else {
                        this.styleContainer = 'container-fluid';
                    }
                }
            });
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    onLinkClick(event: MouseEvent, path: string) {
        if ((event.ctrlKey || event.metaKey) && event.target instanceof HTMLAnchorElement) {
            const urlTree = this.router.createUrlTree([path]);
            const newTabUrl = '#' + this.router.serializeUrl(urlTree);
            window.open(newTabUrl, '_blank');
        }
    }

    openLogin() {
        window.location.href = this.loginUrl; // Use environment variable
    }

    toggleMenu() {
      
        this.isSubMenu = !this.isSubMenu;
       
    }

    openDomainSubMenu() {
        this.isDomainSubmenu = !this.isDomainSubmenu;
        this.isAboutubmenu = false;
        this.isServiceSubmenu = false;
    }

    openServiceSubMenu() {
        this.isServiceSubmenu = !this.isServiceSubmenu;
        this.isAboutubmenu = false;
        this.isDomainSubmenu = false;
    }

    openAboutSubMenu() {
        this.isAboutubmenu = !this.isAboutubmenu;
        this.isDomainSubmenu = false;
        this.isServiceSubmenu = false;
    }
}
